
/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Inventory {

    import fld = SKUSplittingItemsRow.Fields;
    @Serenity.Decorators.registerClass()
    export class SKUSplittingItemsEditor extends _Ext.ItemGridEditor<SKUSplittingItemsRow> {


        protected getColumnsKey() { return "Inventory.SKUSplittingItems"; }
        protected getDialogType() { return SKUSplittingItemsDialog; }
        protected getLocalTextPrefix() { return SKUSplittingItemsRow.localTextPrefix; }
        protected form: SKUSplittingItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU = true;
        private contractTotals: string;
        public TotalItems: number;
        statement: string;

        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: false });
        }



        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);


            Q.first(columns, x => x.field === fld.Weight).format = num;

            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }
        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);
            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {

                        var id = this.id(item);
                        this.TotalItems = this.view.getItems().length - 1;
                        this.view.deleteItem(id);

                    });
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }


        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Weight || field === fld.Discount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***

            if (field === fld.Weight) {
                if (item.CalcOnId != 3 && item.HasBom == false) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.UnitRate + labr) * value;
                    item.NetAmount = Net;
                    item.NetWeight = value;
                    item.GrossAmount = Net;
                    if (item.WstPer != null) {
                        item.WstWt = value * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion

        //Set Data for New SKU Generated
        public setData(entity: SKUSplittingDetailsRow, _productid: number, AtbId: number, count: number, stockid: number, exchangerate: number, date: Date) {
            var x = entity;
            var netwtperitem = 0;
            var weightperitem = 0;
            var AllowSKUSplitting = q.ToBool(TabAurous.GetConfigValue(1009));
            if (AllowSKUSplitting && count > entity.Pieces) {
                netwtperitem = entity.NetWeight / count;
                weightperitem = entity.Weight / count;
            }
            else if (!x.HasBom) {
                netwtperitem = entity.NetWeight;
                weightperitem = entity.Weight;
            }
            else if (x.HasBom) {
                netwtperitem = entity.NetWeight / entity.Pieces;
                weightperitem = entity.Weight / entity.Pieces;
            }



            var StockIds = [];
            StockIds.push(stockid);
            var BOM: Stock.StockItemBOMRow[];
            //Stock.StockItemBOMService.GetStockBOM({ StockIds: StockIds }, response => BOM = response.Entities, { async: false });

            for (var i = 0; i < count; i++) {
                var SKU = FormatHelper.GetFormats("SKU");

                var bomitems = [];
                /*
                for (var j = 0; j < BOM.length; j++) {

                    var Amount = 0
                    if (BOM[j].CalcOnId != 3) {
                        var wt = count > entity.Pieces ? BOM[j].Weight / count : BOM[j].Weight / entity.Pieces
                        Amount = wt * BOM[j].BomRate;
                    }
                    else {
                        var pcs = count > entity.Pieces ? BOM[j].Pieces / count : BOM[j].Pieces / entity.Pieces
                        Amount = pcs * BOM[j].BomRate;
                    }


                    var bomitem: SKUSplittingBOMRow = {
                        BomAmount: Amount,
                        CCBomAmount: Amount,
                        BOMAttributeId: BOM[j].BOMAttributeId,
                        BomRate: BOM[j].BomRate,
                        CalcOnId: BOM[j].CalcOnId,
                        CertificateNo: BOM[j].CertificateNo,
                        Lab: BOM[j].Lab,
                        Pieces: count > entity.Pieces ? BOM[j].Pieces / count : BOM[j].Pieces / entity.Pieces,
                        BOMProductId: BOM[j].BOMProductId,
                        ProductCode: BOM[j].ProductCode,
                        ProductId: BOM[j].ProductId,
                        ItemTypeId: BOM[j].ItemTypeId,
                        Remarks: BOM[j].Remarks,
                        SettingId: BOM[j].SettingId,
                        //StoneStatusId: BOM[j].StoneStatusId,
                        Weight: count > entity.Pieces ? BOM[j].Weight / count : BOM[j].Weight / entity.Pieces,
                        RefStockBomId: BOM[i].StockBomId,
                        RefTransBomId: BOM[i].StockBomId,
                        Purity: BOM[i].Purity,
                        Line_No: BOM[i].Line_No,
                        PureWeight: count > entity.Pieces ? BOM[i].PureWeight / count : BOM[i].PureWeight / entity.Pieces
                    }
                    bomitems.push(bomitem);

                }
                */
                var Rate = 0;
                var Amount = 0;
                var Cost = 0;
                var LaborRate = 0;
                var labordetail = [];

                // #region FG
                if (entity.ItemTypeId == 101) {
                    let LaborOpt: TabAurous.RateHelper.LaborCalOptions = {
                        ProductId: entity.ProductId,
                        AttributeId: entity.AttributeId,
                        RateListId: 0,
                        Markup: 0,
                        Pieces: entity.Pieces,
                        Weight: entity.Weight,
                        NetWeight: entity.NetWeight
                    }
                    var ItemLabor: Sales.SalesLaborRow[] = RateHelper.GetSalesLabour(LaborOpt)
                    if (ItemLabor != null)
                        for (var l = 0; l < ItemLabor.length; l++) {
                            ItemLabor[l].LabourRate = ItemLabor[l].LabourRate / exchangerate;
                            ItemLabor[l].LabourAmount = ItemLabor[l].LabourAmount / exchangerate;
                            ItemLabor[l].CCLabourAmount = ItemLabor[l].LabourAmount;
                            LaborRate += ItemLabor[l].LabourAmount;
                            labordetail.push(ItemLabor[l]);
                        }


                }

                // #endregion

                // #region Amount Calculation
                if (entity.ItemTypeId == 101) {
                    Cost = Rate + LaborRate;
                    Amount = entity.HasBom == true ? (Rate + LaborRate) * entity.Pieces : (Rate * entity.Weight) * entity.Purity || 0;
                }
                else if (entity.ItemTypeId == 104) {
                    Cost = Rate + LaborRate;
                    Amount = entity.CalcOnId == 3 ? (Rate + LaborRate) * entity.Pieces : (Rate * entity.Weight) * entity.Purity || 0;

                }
                else if (entity.ItemTypeId == 105) {
                    Cost = Rate + LaborRate;
                    Amount = entity.CalcOnId == 3 ? (Rate + LaborRate) * entity.Pieces : Rate * entity.Weight || 0;
                }

                if (bomitems.length > 0) {
                    bomitems.forEach(function (BOMItem) {
                        Rate += BOMItem.BomAmount;
                    })
                }
                else {
                    Rate = entity.UnitRate;
                }

                var item: SKUSplittingItemsRow = {
                    ProductId: _productid,
                    ProductCode: x.ProductCode,
                    ProductName: x.ProductName,
                    AttributeId: AtbId,
                    CalcOnId: x.CalcOnId,
                    CompanyId: x.CompanyId,
                    DepartmentId: x.DepartmentId,
                    SKU: SKU,
                    Pieces: x.Pieces,
                    Weight: weightperitem,
                    NetWeight: netwtperitem,
                    Line_No: x.Line_No,
                    ItemTypeId: x.ItemTypeId,
                    ProductTypeId: x.ProductTypeId,
                    CategoryId: x.CategoryId,
                    SubCategoryId: x.SubCategoryId,
                    BrandId: x.BrandId,
                    SuperTypeId: x.SuperTypeId,
                    CollectionId: x.CollectionId,
                    KaratId: x.KaratId,
                    MetalId: x.MetalId,
                    MetalColorId: x.MetalColorId,
                    DiamondPieces: count > entity.Pieces ? x.DiamondPieces / count : x.DiamondPieces / entity.Pieces,
                    DiamondAmount: count > entity.Pieces ? x.DiamondAmount / count : x.DiamondAmount / entity.Pieces,
                    DiamondWeight: count > entity.Pieces ? x.DiamondWeight / count : x.DiamondWeight / entity.Pieces,
                    OtherAmount: x.OtherWeight * Rate,// count > entity.Pieces ? x.OtherAmount / count : x.OtherAmount / entity.Pieces,
                    OtherPieces: count > entity.Pieces ? x.OtherPieces / count : x.OtherPieces / entity.Pieces,
                    OtherWeight: count > entity.Pieces ? x.OtherWeight / count : x.OtherWeight / entity.Pieces,
                    StoneAmount: 0,
                    StonePieces: count > entity.Pieces ? x.StonePieces / count : x.StonePieces / entity.Pieces,
                    StoneWeight: count > entity.Pieces ? x.StoneWeight / count : x.StoneWeight / entity.Pieces,
                    BagNo: x.BagNo,
                    CertificateNo: x.CertificateNo,
                    HSN: x.HSN,
                    RefTransId: 0,
                    RefTransItemId: 0,
                    RefVoucherId: 0,
                    BOMDetails: bomitems,
                    PartyId: entity.PartyId,
                    UnitRate: Rate,
                    NetAmount: entity.CalcOnId != 3 ? Rate * weightperitem : Rate * 1,
                    GrossAmount: entity.CalcOnId != 3 ? Rate * weightperitem : Rate * 1,
                    HasBom: x.HasBom,
                    LotNo: x.LotNo,
                    Lab: x.Lab,
                    StockAllocation: false,
                    DesignId: x.DesignId,
                    TaxCode: x.TaxCode,
                    LaborDetails: labordetail,
                    StoneRate: 0,
                    RefNo: x.RefNo,
                    ProductSizeId: x.ProductSizeId,
                    StampId: x.StampId,
                    Studded: 1,

                };
                //item.TransItemId = this.nextId++;
                item[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(item);
            }

        }

        public setOldItems(entity: any[]) {
            for (var i = 0; i < entity.length; i++) {
                entity[i][this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(entity[i]);
            }
        }
        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");

            return [];
        }



        // #endregion




    }
}